// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"h1-z","categoryName":"i1-z","categoryImage":"j1-z","categoryContent":"k1-z","bottomAligned":"l1-z"};